import {useEffect, useReducer} from "react"
import {LocalContext} from "../contexts/LocalContext"
import LocalReducer from "../reducers/localReducer"

const initialState = {
    minNavigation: false,
    lang: "en-US"
}

export default function LocalProvider({children}) {
    const [localContext, setLocalAction] = useReducer(
        LocalReducer,
        initialState,
        () => {
            try {
                const stored = localStorage.getItem("localContext")
                return stored ? JSON.parse(stored) : initialState
            } catch (error) {
                console.error("Failed to parse localContext from localStorage", error)
                return initialState
            }
        }
    )

    useEffect(() => {
        if (localContext) {
            localStorage.setItem("localContext", JSON.stringify(localContext))
        } else {
            localStorage.removeItem("localContext")
        }
    }, [localContext])

    return (
        <LocalContext.Provider value={{localContext, setLocalAction}}>
            {children}
        </LocalContext.Provider>
    )
}